/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UiCheckbox } from '../../ui-checkbox/ui-checkbox';
import { Mixin } from '../../../mixins/Mixin';
import { Filterable } from '../../../mixins/Filterable';

@Component({
    selector: 'fe-checkbox',
    template: require('./fe-checkbox.html'),
    styles: [require('./fe-checkbox.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: FeCheckbox, multi: true}
    ]
})

@Mixin([Filterable])
export class FeCheckbox extends UiCheckbox {

    constructor(public elementRef: ElementRef) {
        super(elementRef);
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/form-elements/fe-checkbox/fe-checkbox.ts